import Constants from '../Constants';

export const MAP_76CL_PERFORMANCE = 'MAP_76CL_PERFORMANCE';
export const MAP_ORDERS_CL = 'MAP_ORDERS_CL';
export const MAP_TODAYS_ORDERS = 'MAP_TODAYS_ORDERS';
export const MAP_RISK_MANAGED_VOLUME = 'MAP_RISK_MANAGED_VOLUME';
export const MAP_DELIVERED_ON_TIME = 'MAP_DELIVERED_ON_TIME';
export const MAP_LOAD_WEIGHTS = 'MAP_LOAD_WEIGHTS';
export const MAP_PRODUCT_AGE = 'MAP_PRODUCT_AGE';
export const MAP_FORECAST_ACCURACY = 'MAP_FORECAST_ACCURACY';
export const MAP_FILES_SENT = 'MAP_FILES_SENT';
export const MAP_GRINDER_YIELD = 'MAP_GRINDER_YIELD';
export const MAP_CHEMICAL_LEAN_VALUE = 'MAP_CHEMICAL_LEAN_VALUE';
export const MAP_SINGLE_LOT_TESTED = 'MAP_SINGLE_LOT_TESTED';
export const MAP_AGRIFOODS_FROZEN_INVENTORY = 'MAP_AGRIFOODS_FROZEN_INVENTORY';
export const MAP_COST_SAVINGS = 'MAP_COST_SAVINGS';
export const MAP_CONVERSION_COSTS = 'MAP_CONVERSION_COSTS';
export const MAP_CHEMICAL_LEAN_PERFORMANCE = 'MAP_CHEMICAL_LEAN_PERFORMANCE';
export const MAP_EMPTY = 'MAP_EMPTY';
export const MAP_WEATHER = 'MAP_WEATHER';
export const MAP_CLAIMS = 'MAP_CLAIMS';
export const MAP_SENSORS = 'MAP_SENSORS';
export const MAP_ERROR = 'MAP_ERROR';

function prepQueryString(grinders, packerPlants, startDate, endDate, orderString, shouldFetchAllPODateFields = false) {
  let queryString = '?';
  if (grinders) {
    const grinderUids = grinders.map(grinder => {
      return grinder.uid;
    });
    queryString += `grinder_uids=${grinderUids.join(',')}`;
  }

  if (packerPlants) {
    const packerPlantIds = packerPlants.map(packerPlant => {
      return packerPlant.id;
    });
    const firstCharacter = packerPlants && grinders ? '&' : '';
    queryString += `${firstCharacter}packer_plant_ids=${packerPlantIds.join(',')}`;
  }

  if (shouldFetchAllPODateFields) {
    // US Exports
    const deliveryStartDate = `&delivery_startDate=${startDate}`;
    const deliveryEndDate = `delivery_end_date=${endDate}`;

    // Overseas Exports
    const etaStartDate = `eta_start_date=${startDate}`;
    const etaEndDate = `eta_end_date=${endDate}`;

    queryString += [deliveryStartDate, deliveryEndDate, etaStartDate, etaEndDate].join('&');
  } else {
    if (startDate) {
      queryString += `&${orderString}start_date=${startDate}`;
    }
    if (endDate) {
      queryString += `&${orderString}end_date=${endDate}`;
    }
  }
  return queryString;
}

/* ---------------------------------
    ACTIONS
-----------------------------------*/
export function loadChemicalLeanPerformance(chemicalLeanPerformance) {
  return {
    type: MAP_CHEMICAL_LEAN_PERFORMANCE,
    payload: chemicalLeanPerformance,
  };
}
export function loadForecastAccuracy(forecastAccuracy) {
  return {
    type: MAP_FORECAST_ACCURACY,
    payload: forecastAccuracy,
  };
}
export function loadFilesSent(filesSent) {
  return {
    type: MAP_FILES_SENT,
    payload: filesSent,
  };
}
export function loadSingleLotTested(singleLotTested) {
  return {
    type: MAP_SINGLE_LOT_TESTED,
    payload: singleLotTested,
  };
}
export function loadSensors(sensors) {
  return {
    type: MAP_SENSORS,
    payload: sensors,
  };
}
export function loadAgrifoodsFrozenInventory(agrifoods) {
  return {
    type: MAP_AGRIFOODS_FROZEN_INVENTORY,
    payload: agrifoods,
  };
}
export function loadConversionCosts(conversionCosts) {
  return {
    type: MAP_CONVERSION_COSTS,
    payload: conversionCosts,
  };
}
export function loadProductAge(productAge) {
  return {
    type: MAP_PRODUCT_AGE,
    payload: productAge,
  };
}
export function loadOrdersCL(ordersCL) {
  return {
    type: MAP_ORDERS_CL,
    payload: ordersCL,
  };
}
export function loadRiskManagedVolume(riskManagedVolume) {
  return {
    type: MAP_RISK_MANAGED_VOLUME,
    payload: riskManagedVolume,
  };
}
export function loadDeliveredOnTime(deliveredOnTime) {
  return {
    type: MAP_DELIVERED_ON_TIME,
    payload: deliveredOnTime,
  };
}
export function loadLoadWeights(loadWeights) {
  return {
    type: MAP_LOAD_WEIGHTS,
    payload: loadWeights,
  };
}
export function loadCostSavings(costSavings) {
  return {
    type: MAP_COST_SAVINGS,
    payload: costSavings,
  };
}
export function loadChemicalLeanValue(chemicalLeanValue) {
  return {
    type: MAP_CHEMICAL_LEAN_VALUE,
    payload: chemicalLeanValue,
  };
}
export function loadPerformance(performance) {
  return {
    type: MAP_76CL_PERFORMANCE,
    payload: performance,
  };
}
export function loadClaims(claims) {
  return {
    type: MAP_CLAIMS,
    payload: claims,
  };
}
export function loadWeather(weather) {
  return {
    type: MAP_WEATHER,
    payload: weather,
  };
}
export function loadGrinderYield(grinderYield) {
  return {
    type: MAP_GRINDER_YIELD,
    payload: grinderYield,
  };
}
export function loadTodaysOrders(orders) {
  return {
    type: MAP_TODAYS_ORDERS,
    payload: orders,
  };
}
export function loadEmpty() {
  return {
    type: MAP_EMPTY,
    payload: [],
  };
}
export function errorMap(error) {
  return {
    type: MAP_ERROR,
    payload: error,
  };
}

/* ---------------------------------
    THUNKS
-----------------------------------*/
export function fetchTodaysOrders(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '', true);
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/ops${queryString}&status=received,ordered,invoiced,dispatched,complete`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadTodaysOrders(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchAgrifoodsFrozenInventory(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/agrifoods_frozen_inventory${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadAgrifoodsFrozenInventory(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchGrinderYield(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/grinder_yield${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadGrinderYield(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchConversionCosts(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/conversion_costs${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadConversionCosts(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchChemicalLeanPerformance(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(false, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/chemical_lean_performance${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadChemicalLeanPerformance(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchChemicalLeanValue(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/chemical_lean_value${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadChemicalLeanValue(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchCostSavings(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/cost_savings${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadCostSavings(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchClaims(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/claims${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => {
        dispatch(loadClaims(json));
      })
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchForecastAccuracy(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/forecast_accuracy${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => {
        // var tempData = {'grinders': [
        // 	{'grinder_id': 1, 'error_pc': 0.7, 'forecast_quanity': 700000, 'production_quantity': 1000000},
        //   {'grinder_id': 3, 'error_pc': 0.5, 'forecast_quanity': 600000, 'production_quantity': 300000},
        //   {'grinder_id': 4, 'error_pc': 0.2, 'forecast_quanity': 1000000, 'production_quantity': 1200000}
        // 	],
        //  'packer_grinder': [],
        //  'packers': [],
        //  'system': {'error_pc': 0.6, 'forecast_quanity': 1300000, 'production_quantity': 1300000}};
        //  dispatch(loadForecastAccuracy(tempData))
        dispatch(loadForecastAccuracy(json));
      })
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchFilesSent(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/files_sent${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => {
        dispatch(loadFilesSent(json));
      })
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchSingleLotTested(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/single_lot_tested${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => {
        dispatch(loadSingleLotTested(json));
      })
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchPerformance(grinders, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, false, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/76cl_performance${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadPerformance(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchProductAge(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/product_age${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => {
        // var testJson = {"packer_grinder": [{"volume": 44000, "weighted_average_product_age": 3.5, "grinder_id": 4, "packer_id": 32}, {"volume": 40000, "weighted_average_product_age": 2.0, "grinder_id": 4, "packer_id": 2}, {"volume": 80000, "weighted_average_product_age": 2.5, "grinder_id": 4, "packer_id": 3}, {"volume": 42000, "weighted_average_product_age": 3.0, "grinder_id": 3, "packer_id": 36}, {"volume": 200000, "weighted_average_product_age": 2.2, "grinder_id": 4, "packer_id": 36}, {"volume": 80000, "weighted_average_product_age": 3.0, "grinder_id": 5, "packer_id": 36}, {"volume": 168000, "weighted_average_product_age": 2.9761904761904763, "grinder_id": 4, "packer_id": 37}, {"volume": 40000, "weighted_average_product_age": 3.0, "grinder_id": 5, "packer_id": 34}, {"volume": 40000, "weighted_average_product_age": 2.0, "grinder_id": 5, "packer_id": 5}, {"volume": 80000, "weighted_average_product_age": 2.5, "grinder_id": 5, "packer_id": 8}, {"volume": 80000, "weighted_average_product_age": 2.0, "grinder_id": 4, "packer_id": 12}, {"volume": 600000, "weighted_average_product_age": 2.066666666666667, "grinder_id": 5, "packer_id": 12}, {"volume": 80000, "weighted_average_product_age": 2.0, "grinder_id": 4, "packer_id": 18}, {"volume": 200000, "weighted_average_product_age": 2.0, "grinder_id": 5, "packer_id": 18}, {"volume": 120000, "weighted_average_product_age": 2.0, "grinder_id": 5, "packer_id": 20}, {"volume": 40000, "weighted_average_product_age": 2.0, "grinder_id": 4, "packer_id": 21}, {"volume": 40000, "weighted_average_product_age": 3.0, "grinder_id": 5, "packer_id": 21}, {"volume": 40000, "weighted_average_product_age": 2.0, "grinder_id": 5, "packer_id": 23}, {"volume": 80000, "weighted_average_product_age": 2.0, "grinder_id": 5, "packer_id": 25}, {"volume": 42000, "weighted_average_product_age": 2.0, "grinder_id": 3, "packer_id": 29}, {"volume": 208000, "weighted_average_product_age": 2.0, "grinder_id": 4, "packer_id": 29}, {"volume": 120000, "weighted_average_product_age": 1.6666666666666667, "grinder_id": 5, "packer_id": 29}], "grinders": [{"volume": 84000, "weighted_average_product_age": 2.5, "grinder_id": 3}, {"volume": 940000, "weighted_average_product_age": 2.3297872340425534, "grinder_id": 4}, {"volume": 1440000, "weighted_average_product_age": 2.138888888888889, "grinder_id": 5}], "packers": [{"volume": 44000, "weighted_average_product_age": 3.5, "packer_id": 32}, {"volume": 40000, "weighted_average_product_age": 2.0, "packer_id": 2}, {"volume": 80000, "weighted_average_product_age": 2.5, "packer_id": 3}, {"volume": 322000, "weighted_average_product_age": 2.5031055900621118, "packer_id": 36}, {"volume": 168000, "weighted_average_product_age": 2.9761904761904763, "packer_id": 37}, {"volume": 40000, "weighted_average_product_age": 3.0, "packer_id": 34}, {"volume": 40000, "weighted_average_product_age": 2.0, "packer_id": 5}, {"volume": 80000, "weighted_average_product_age": 2.5, "packer_id": 8}, {"volume": 680000, "weighted_average_product_age": 2.0588235294117645, "packer_id": 12}, {"volume": 280000, "weighted_average_product_age": 2.0, "packer_id": 18}, {"volume": 120000, "weighted_average_product_age": 2.0, "packer_id": 20}, {"volume": 80000, "weighted_average_product_age": 2.5, "packer_id": 21}, {"volume": 40000, "weighted_average_product_age": 2.0, "packer_id": 23}, {"volume": 80000, "weighted_average_product_age": 2.0, "packer_id": 25}, {"volume": 370000, "weighted_average_product_age": 1.8918918918918919, "packer_id": 29}], "system": {"volume": 2464000, "weighted_average_product_age": 2.2240259740259742}};
        // dispatch(loadProductAge(testJson))
        dispatch(loadProductAge(json));
      })
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchOrdersCL(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/orders_cl${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadOrdersCL(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchRiskManagedVolume(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/risk_managed_volume${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadRiskManagedVolume(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchDeliveredOnTime(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/delivered_on_time${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadDeliveredOnTime(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchLoadWeights(grinders, packerPlants, startDate, endDate, token) {
  return dispatch => {
    const queryString = prepQueryString(grinders, packerPlants, startDate, endDate, '');
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}dashboard/load_weights${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadLoadWeights(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchSensors(startDate, endDate, token) {
  return dispatch => {
    const queryString = `?start_date=${startDate}&end_date=${endDate}`;
    const header = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    });
    return fetch(`${Constants.URL}sensors/data${queryString}`, {
      method: 'GET',
      headers: header,
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadSensors(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchWeather() {
  return dispatch => {
    return fetch('https://api.weather.gov/alerts/active', {
      method: 'GET',
    })
      .then(response => Constants.handleErrors(response, dispatch, errorMap))
      .then(json => dispatch(loadWeather(json)))
      .catch(error => dispatch(errorMap(error)));
  };
}

export function fetchEmpty() {
  return dispatch => {
    dispatch(loadEmpty());
  };
}
